module.exports = __webpack_public_path__ + "img/icon_project.1efc06e8.svg";